// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"a514c3c8","197":"6676acc9","724":"6d1f39b9","725":"ec505879","759":"88d1d822","897":"549e1633"}[chunkId] + ".chunk.js";
};